
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { setUser } from '../../redux/actions';
import SpinnerPage from '../SpinnerPage/SpinnerPage';


const mapStateToProps = (state) => {
	return {
		user: state.app.user,
		lang: state.app.lang
	}
}

const ProtectedRoute = (props) => {

	const loginPath = '/';
	let location = useLocation();

	if (location && location.pathname === "/activation" && location.state && location.state.route === "setup" && !props.user)
		return <Navigate to={"/"} state={{ from: location }} replace />

	if (location && location.pathname === "/activation" && !props.user)
		return <SpinnerPage state={{ from: location }} />

	if (location && location.pathname === "/activation" && props.user && (props.user.attributes["custom:activation_token"] || props.user.attributes["custom:internal_user_id"]))
		return <Navigate to={"/launch"} state={{ from: location }} replace />


	if (location && location.pathname === "/activation" && props.user && (!props.user.attributes["custom:activation_token"] && !props.user.attributes["custom:internal_user_id"]))
		return props.children;

	// during signin, user authenticated successfully, but still waiting for the user object to be loaded
	// so, display spinner
	if (location && !props.user) {
		return <Navigate to={loginPath} state={{ from: location }} replace />
	}

	return props.children

}

export default connect(mapStateToProps, { setUser })(ProtectedRoute);
